module.exports = __webpack_public_path__ + "static/media/volleyball_icon-01.f79c2d73.png";